module.exports = __webpack_public_path__ + "img/aaaaa.fbcbe252.png";